import { createSlice } from '@reduxjs/toolkit'

import { userApi } from '../services/user'

const initialState = {
    userRole: 'Guest',
    currentUser: undefined,
    appIsLoading: true,
    language: 'en-US',
    showDrawingDoctorLegend: true,
    locale: 'en-US',
    languageList: {
        'en-US': {
            nativeName: 'English',
            region: 'US',
        },
    },
}

export const appSlice = createSlice({
    name: 'appSlice',
    initialState,
    reducers: {
        setUserRole: (state, action) => {
            state.userRole = action.payload
        },

        setCurrentUser: (state, action) => {
            state.currentUser = { ...state.currentUser, ...action.payload }
        },

        setAppIsLoading: (state, action) => {
            state.appIsLoading = action.payload
        },

        setLanguage: (state, action) => {
            state.language = action.payload
        },

        setLocale: (state, action) => {
            state.locale = action.payload
        },

        setLanguageList: (state, action) => {
            state.languageList = action.payload
        },
        unsetUser: (state) => {
            state.currentUser = undefined
        },
        setShowDrawingDoctorLegend: (state, action) => {
            state.showDrawingDoctorLegend = action.payload
        },
        toggleShowDrawingDoctorLegend: (state) => {
            state.showDrawingDoctorLegend = !state.showDrawingDoctorLegend
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(userApi.endpoints.getOrCreateUserContext.matchFulfilled, (state, { payload }) => {
                state.currentUser = { ...state.currentUser, ...payload.user }
            })
            .addMatcher(userApi.endpoints.updateUser.matchFulfilled, (state, { payload }) => {
                state.currentUser = { ...state.currentUser, ...payload }
            })
    },
})

export const selectUserRole = (state) => state.appSlice.userRole
export const selectCurrentUser = (state) => state.appSlice.currentUser
export const selectCurrentUserId = (state) => state.appSlice.currentUser?.userId
export const selectCurrentUserOrganisations = (state) => state.appSlice.currentUserOrganisations
export const selectAppIsLoading = (state) => state.appSlice.appIsLoading
export const selectAppBarState = (state) => state.appSlice.appBarState
export const selectActivationState = (state) => state.appSlice.activationState
export const selectLanguage = (state) => state.appSlice.language
export const selectLocale = (state) => state.appSlice.locale
export const selectLanguageList = (state) => state.appSlice.languageList
export const selectDisplayOrderPricing = (state) => state.appSlice.displayOrderPricing
export const selectSubscription = (state) => state.appSlice.subscription
export const selectShowDrawerMenu = (state) => state.appSlice.showDrawerMenu
export const selectShowNestedDrawerMenu = (state) => state.appSlice.showNestedDrawerMenu
export const selectIsSubscriptionSet = (state) => {
    const subscriptionExists = state?.appSlice?.subscription
    return Boolean(subscriptionExists && Object.keys(subscriptionExists).length)
}
export const selectIsCurrentUserAdmin = (state) => state.appSlice.userRole === 'administrator'
export const selectIsCurrentUserOwner = (state) => state.appSlice.userRole === 'owner'
export const selectShowDrawingDoctorLegend = (state) => state.appSlice.showDrawingDoctorLegend

export const {
    setAppIsLoading,
    setCurrentUser,
    setLanguage,
    setLanguageList,
    setLocale,
    setShowDrawingDoctorLegend,
    setUserRole,
    toggleShowDrawingDoctorLegend,
    unsetUser,
} = appSlice.actions

export default appSlice.reducer
